<template>
  <div class="content">
    <div style="padding:15px;margin-bottom:0">
      <div class="title title-left">
      <p class="title-line"></p>
        问答问题：
      </div>
      <div>
        <span class="ml10">{{ data.answer }}</span>
      </div>
      <div class="title title-left"><p class="title-line"></p>资料：</div>
      <div class="name">
        <div class="ml10">
          姓名：<span>{{ data.name }}</span>
        </div>
        <div class="ml10">
          性别：<span>{{ data && data.sex == 1 ? "男" : "女" }}</span>
        </div>
      </div>
      <div class="ml10">
        出生年月日：<span>{{data.lunar == 1 ? '阴历' : '公历'}}{{ data.birthday }}</span>
      </div>
      <div class="ml10">
        出生时辰：<span>{{ data.time }}</span>
      </div>
      <div style="margin-bottom:0" class="ml10">
        随机数字：<span>{{ data.num }}</span>
      </div>
    </div>
    
    <div v-if="data && data.TeacherAnswerNum < 2" style="padding:15px;">
      <textarea
        placeholder="请输入问题解答"
        v-model="contents"
        name=""
        id=""
        cols="30"
        rows="10"
      ></textarea>
    </div>
    <div class="buton" @click="submit" style="margin:15px" v-if="data && data.TeacherAnswerNum < 2">
      {{tName}}提交
    </div>
    <div class="line" style="margin-bottom:0"></div>
    <div class="title title-left" style="padding:15px;padding-bottom:0"><p class="title-line"></p>老师解答：</div>
     <!-- v-if="data && data.TeacherAnswerNum > 0" -->
    <div>
      <div v-for="(item, index) in data.TeacherAnswer" :key="index" class="sers-l">
        <div class="t-content">
          <img :src="item.tAvatar" class="img-h">
          <div style="margin-left:.2rem;margin-bottom:0">
            <p style="color:#333">{{item.tName}}</p>
            <p style="font-weight: normal;">{{item.created_time}}</p>
          </div>
        </div>
        <div v-for="(i1,inx1) in item.list" :key="inx1" class="ser-list">
          <p v-html="i1.content"></p>
          <div v-if="inx1 == 0 && item.list.length > 1" style="color:#2fb1ad;margin-top:14px">补充回答</div>
        </div>
      </div>
    </div>
      
    
   
  </div>
</template>

<script>
/**
@description:问答详情
@createTime:2021-09-01
@create:wq
*/

export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      id: "",
      data: "",
      contents: "",
      aoid:'',
      tName:''
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.aoid = this.$route.query.aoid;
    if (this.$route.query && this.$route.query.id && this.aoid) {
      this.id = this.$route.query.id;
      this.teacherAnswerDetails();
    }
  },
  methods: {
    teacherAnswerDetails() {
      this.api.teacherAnswerDetails({ id: this.id ,aoid:this.aoid}).then((res) => {
        this.data = res.data;
        this.tName = this.data.tName
      });
    },
    submit() {
      if (!this.contents) return this.Toast("请输入问题解答");
      this.Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      this.api
        .teacherAnswer({ id: this.data.id, contents: this.contents ,aoid:this.aoid})
        .then(() => {
          this.Toast.clear();
          this.Toast.success("成功");
          setTimeout(() => {
            this.$router.back();
          }, 2000);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.title-left {
  font-size: 0.32rem;
  font-weight: 400;
  color: #666666;
  display: flex;
  align-items: center;
  .title-line {
    width: 4px;
    height: 16px;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
    margin-right: 6px;
  }
}
.ml10{
  margin-left: 10px;
}
.title{
  color: #2fb1ad;
  display: flex;
  align-items: center;
}
.img-h{
  width: .9rem;
  height: .9rem;
  border-radius: 50%;
  object-fit: cover;
}
.t-content{
  display: flex;
  align-items: center;
  margin-bottom: .1rem !important;
}
.ser-list{
  margin-left: 1.1rem;
  font-weight: normal !important;
  color: #333;
}
.sers-l{
  border-bottom: 1px solid #ddd;
  padding: 15px;
  padding-left: 25px;
}
.sers-l:last-child{
  border-bottom: 0;
}
.content {
  font-size: 0.3rem;
  font-weight: bold;
  color: #999999;
  // background: #f6f6f6;
  border-radius: 5px;
  // border: 1px solid #efefef;
  // padding: 14px;
  span {
    color: #333333;
  }
  div {
    margin-bottom: 14px;
  }
}
.name {
  overflow: hidden;
  > div {
    float: left;
    margin-bottom: 0;
    margin-right: 14px;
  }
}
.line {
  width: 100%;
  height: 1px;
  background: #efefef;
  height: .2rem;
}
textarea {
  resize: none;
  width: 100%;
  border: none;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
  font-weight: 500;
  background: #f6f6f6;
}
</style>
